import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { SmartImage } from "@/components/site/SmartImage";

// Final approved Human Home Living artwork (HHL LOGO2.png), used exactly as supplied.
// hhl-logo-full.png is the trimmed master; hhl-logo.png is the same artwork resized for the header.
const LOGO_SRC = "/hhl-logo.png?v=4";
const LOGO_W = 439;
const LOGO_H = 180;

export const Logo = ({ to = "/" }) => {
  const [failed, setFailed] = useState(false);
  const { pathname, hash } = useLocation();

  const content = failed ? (
    <span className="display font-normal text-[21px] md:text-[23px] tracking-tight leading-none">
      Human Home Living
    </span>
  ) : (
    <SmartImage
      src={LOGO_SRC}
      priority
      width={LOGO_W}
      height={LOGO_H}
      onError={() => setFailed(true)}
      alt=""
      aria-hidden="true"
      className="h-[44px] sm:h-[48px] md:h-[58px] lg:h-[64px] xl:h-[72px] w-auto select-none"
      style={{ aspectRatio: `${LOGO_W} / ${LOGO_H}` }}
    />
  );

  if (!to) return content;
  // Navigating to the route the visitor is already on does not re-run the router's scroll reset,
  // so the logo handles that case itself: jump straight to the top, no animation.
  const onClick = (e) => {
    if (pathname !== to || hash) return;
    e.preventDefault();
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };
  return (
    <Link
      to={to}
      onClick={onClick}
      data-testid="site-logo"
      aria-label="Human Home Living home"
      className="inline-flex items-center shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-sage"
    >
      {content}
    </Link>
  );
};
